module.exports = "<div class=\"container\">\r\n    <div class=\"row\">\r\n        <div class=\"col-12 col-md-12 m-t-25\">\r\n            <h2>{{model.title}}</h2>\r\n        </div>\r\n        <div class=\"col-12 col-md-12 m-t-15\" [innerHTML]=\"model.content\">\r\n        </div>\r\n    </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/components/content-page/content.page.component.html
// module id = ./src/components/content-page/content.page.component.html
// module chunks = main